<template>
  <div :class="$style.box">
    <el-row :gutter="20">
      <el-col :span="item.span" v-for="(item, index) in model" :key="index" :class="$style.filterItem">
        <span :class="$style.label">{{ item.label }}</span>
        <!-- 普通输入框 -->
        <el-input v-if="item.type === 'input'" v-model="formData[item.key]" :placeholder="item.placeholder" :class="$style.value"></el-input>
        <!-- 下拉选择框 -->
        <el-select
          v-if="item.type === 'select'"
          v-model="formData[item.key]"
          :placeholder="item.placeholder"
          filterable
          :default-first-option="true"
          :multiple="item.isMultiple"
          collapse-tags
          :clearable="item.clearable"
          :class="$style.value"
        >
          <el-option v-for="(optionItem, optionIndex) in item.options" :key="optionIndex" :label="optionItem.label || optionItem.name" :value="optionItem.id || optionItem.value"></el-option>
          <!-- :value="optionItem.value || optionItem.id" -->
        </el-select>
        <!-- 级联选择器 -->
        <el-cascader
          v-if="item.type === 'cascader'"
          :placeholder="item.placeholder"
          :options="item.options"
          :props="{ multiple: true }"
          filterable
          clearable
          collapse-tags
          :value="formData[item.key]"
          :class="$style.value"
        ></el-cascader>
        <!-- 日期选择器 -->
        <el-date-picker
          v-if="item.type === 'date-picker'"
          :value="formData[item.key] || handleDefaultDate(item)"
          @input="handleDataPickerChange($event, item.key, item.pick)"
          :type="item.dateType ? 'date' : 'daterange'"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          placeholder="选择日期"
          :clearable="false"
          :class="$style.value"
        ></el-date-picker>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <!-- 按钮 -->
      <el-col :class="$style.btnCol" :span="12">
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button id="reset" type="primary" @click="reset" v-show="isReset">重置</el-button>
        <el-button type="primary" @click="add" v-show="isAdd">添加</el-button>
        <el-button type="primary" @click="exp" v-show="isExp">导出</el-button>
        <el-button type="primary" @click="time" v-show="isTime">超时时间</el-button>
        <slot name="button"></slot>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isReset: {
      type: Boolean,
      default: false,
    },
    isAdd: {
      type: Boolean,
      default: false,
    },
    isExp: {
      type: Boolean,
      default: false,
    },
    isTime: {
      type: Boolean,
      default: false,
    },
    lead: {
      type: Object,
      default: function () {
        return { show: false };
      },
    },
  },
  data() {
    return {
      formData: {
        start_date: '',
        end_date: '',
        approval_admin_id: [],
        err_admin_id: [],
      },
      currentDate: [new Date(), new Date()],
    };
  },
  computed: {
    dayBefore() {
      const date = new Date(new Date() - 1000 * 60 * 60 * 24);
      return [date, date];
    },
    showDayWeek() {
      const dateWeek = new Date(new Date() - 1000 * 60 * 60 * 24 * 7);
      return [dateWeek, new Date()];
    }
  },
  methods: {
    search() {
      this.$emit('search', this.formData);
    },
    reset() {
      this.formData = {
        approval_admin_id: [],
        err_admin_id: [],
      };
      this.$emit('reset');
    },
    add() {
      this.$emit('add');
    },
    // 导出
    exp() {
      this.$emit('exp', this.formData);
    },
    time() {
      this.$emit('time');
    },
    handleDataPickerChange(e, key, pick) {
      this.$set(this.formData, key, e);
      if (pick) {
        this.formData['start_date'] = e[0];
        this.formData['end_date'] = e[1];
      }
    },
    leadSuccess() {
      this.$message({
        message: '上传成功',
        type: 'success',
      });
    },
    getNowFormatDate() {
      let date = new Date();
      let seperator1 = '-';
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = '0' + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
      }
      let currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    // 指定默认日期
    handleDefaultDate(item) {
      if (item.showDefault) return this.currentDate;
      if (item.showDayBefore) return this.dayBefore;
      if (item.showDayWeek) return this.showDayWeek;
      return '';
    },
  },
};
</script>

<style lang="less" module>
.box {
  padding: 15px;

  :global {
    .el-date-editor {
      width: 100%;
    }
  }
  .filterItem {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .label {
      flex: none;
      margin-right: 10px;
      font-size: 15px;
    }

    .value {
      flex: 1;

      :global {
        .el-select {
          width: 100%;
        }
      }
    }
  }
  .btnCol {
    position: relative;
    .upload {
      width: 70px;
      height: 40px;
      float: left;
      margin-right: 20px;
    }
  }
}
</style>
